import type { FC } from 'react';
import { memo } from 'react';

import { BaseStepCount, type IBaseStepCountProps } from './BaseStepCount'
import { strings } from './messages'
import { StepCountStyled } from './styles/StepCountStyled'
import { Space } from '@ui/elements/Space'
import { SubText } from '@ui/elements/Text'

export interface IStepCountProps extends IBaseStepCountProps {
  showLabel?: boolean
  intl?: {
    strings: typeof strings
  }
}

export const StepCount: FC<IStepCountProps> = memo(
  ({
    step = 1,
    total = 1,
    showLabel = true,
    intl = { strings },
    ...baseStepCountProps
  }) => {
    return (
      <StepCountStyled>
        <Space direction='horizontal' size='small' align='center'>
          {showLabel && (
            <SubText inline>
              {intl.strings.steps} {step} {intl.strings.of} {total}
            </SubText>
          )}
          <BaseStepCount step={step} total={total} {...baseStepCountProps} />
        </Space>
      </StepCountStyled>
    )
  }
)
